import React from 'react';
import './SidebarHeader.css';

const SidebarHeader = ({ children, prefix, sufix, isCollapsed }) => {
    return (
        <div className="sidebar-header" style={{justifyContent: isCollapsed ? 'center' : 'space-between'}}>
            {prefix && <div className={`sidebar-header-prefix ${isCollapsed ? '' : 'sidebar-header-prefix-not-collapsed'}`}>{prefix}</div>}
            <div className="sidebar-header-content" style={{display: isCollapsed ? 'none' : 'block'}}>
                {children}
            </div>
            {sufix && <div className={`sidebar-header-suffix ${isCollapsed ? '' : 'sidebar-header-suffix-not-collapsed'}`}>{sufix}</div>}
        </div>
    );
};

export default SidebarHeader;
